import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setDeeplinking } from '../../Redux/Reducers/OnboardingReducer';

const useBackLinkRedirect = () => {
  const dispatch = useDispatch();
  const deeplinkURL = useSelector((state) => state?.onboarding?.deeplinkURL);
  const GetAadharData = useSelector((state) => state?.Kyc?.verifiedGetData?.data?.aadharData);
  const PanGetData = useSelector((state) => state?.Kyc?.verifiedGetData?.data?.panData);
  const isVerified = (value) => value !== "Not verified Yet" && value !== undefined && value !== null;
  const accessToken = localStorage.getItem('objectId');
  const fallbackBase = process.env.REACT_APP_ENTERPRISE_URL;
  const backLinkUrl = deeplinkURL?.split('back_link_url=')?.[1];
  // ;console.log("I AM Outside", backLinkUrl)
  // console.log("backLinkUrlMMM", deeplinkURL)
  /** true when the current session was started from a back_link_url deep-link */
  const hasBackLink = Boolean(backLinkUrl && backLinkUrl.trim() !== '');
  /**c
   * Redirect the browser back to enterprise.
   *
   * @param {string} [extraPath] - optional sub-path to append to the fallback
   *   base URL when no back_link_url is stored (e.g. '/onboarding').
   *   Ignored when a back_link_url is present.
   */

  const buildDestination = useCallback(
    (extraPath = '/onboarding' || '/university-onboarding') => {
      if (hasBackLink) {
        try {
          const url = new URL(backLinkUrl);
          if (accessToken) url.searchParams.set('accessToken', accessToken);
          return url.toString();
        } catch {
          const sep = backLinkUrl.includes('?') ? '&' : '?';
          return accessToken
            ? `${backLinkUrl}${sep}accessToken=${encodeURIComponent(accessToken)}`
            : backLinkUrl;
        }
      }

      if (fallbackBase) {
        return accessToken
      }

      console.error(
        'useBackLinkRedirect: no back_link_url in Redux and REACT_APP_ENTERPRISE_URL is not defined.'
      );
      return null;
    },
    [accessToken, backLinkUrl, fallbackBase, hasBackLink]
  );

  const redirectToEnterprise = useCallback(
    async (extraPath = '/onboarding' || '/university-onboarding') => {
      // console.log("extraPathextraPath", extraPath)
      const destination = buildDestination(extraPath);

      if (!destination) return;

      const isOnboarding = backLinkUrl?.includes('/onboarding');
      const isUniversityOnboarding = backLinkUrl?.includes('/university-onboarding');
      const hasOnboardingPath = isOnboarding || isUniversityOnboarding;
      const isKYCVerified = isVerified(GetAadharData) && isVerified(PanGetData)
      // console.log("isKYCVerified2525", isKYCVerified)
      // console.log('useBackLinkRedirect – redirecting to:', destination);
      // localStorage.removeItem('docType');
      // sessionStorage.removeItem('previousPath');
      // if (backLinkUrl) {
      //   // console.log("I AM Inside", backLinkUrl)
      //   // window.location.replace(backLinkUrl + `?accessToken=${encodeURIComponent(accessToken)}`);
      //   // dispatch(setDeeplinking(""))
      // }
      // if (hasOnboardingPath) {
        localStorage.removeItem('docType');
        sessionStorage.removeItem('previousPath');

        if (backLinkUrl) {
          window.location.replace(backLinkUrl + `?accessToken=${encodeURIComponent(accessToken)}`);
          dispatch(setDeeplinking(""));
        }
      // } else {
        // console.log('Navigation blocked - conditions not met');
        // Handle the case when conditions are not met
      // }

    },
    [buildDestination, dispatch]
  );


  return { redirectToEnterprise, hasBackLink, backLinkUrl };
};

export default useBackLinkRedirect;